import React, { useState } from 'react';
import s from './index.module.css';
import { CloseIcon } from '../Icons';

const DescriptionPopup = ({ header, mainContent, storageKey }) => {
    const storedValue = JSON.parse(localStorage.getItem(storageKey)) || false;
    const [isPopupVisible, setPopupVisible] = useState(!storedValue);

    const onCloseHandler = () => {
        localStorage.setItem(`${storageKey}`, true);
        setPopupVisible(false);
    };

    return (
        <>
            {isPopupVisible && <div className={s.descriptionWrapper}>
                <div className={s.descriptionHeader}>
                    <button className={s.closeButton} onClick={onCloseHandler}>
                        <CloseIcon width={11} height={11} color={'#000000'} />
                    </button>
                </div>
                <div className={s.descriptionBody}>
                    <div className={s.descriptionContent}>{mainContent}</div>
                </div>
                <div className={s.descriptionFooter}>
                    {[0, 1, 2].map((key) => <div key={key} className={s.pointer} />)}
                </div>
            </div>}
        </>
    );
};

export default DescriptionPopup;